var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManage = function SvgManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 9.148a.5.5 0 0 1 .5.5v.7a.5.5 0 0 1-.5.5H6.5a.5.5 0 0 1-.5-.5v-.7a.5.5 0 0 1 .5-.5zM9.5 13a.5.5 0 0 1 .5.5v.699a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-.7a.5.5 0 0 1 .5-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    d: "M16 12h3.5a1 1 0 0 1 1 1v5.3a2.7 2.7 0 0 1-2.7 2.7H16zM3 7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v14H6a3 3 0 0 1-3-3z"
  })));
};
export default SvgManage;